<template>
  <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center z-50 rounded-[10px] w-[100vw] px-[20px]">
    <!-- Modal Overlay -->
    <div class="fixed inset-0 bg-[#80808086] bg-opacity-50 rounded-[10px]" @click="closeModal"></div>

    <!-- Modal Content -->
<div
  class="relative bg-white w-full max-w-[calc(100vw-40px)] max-h-[690px] rounded-[10px] shadow-lg z-10 flex flex-col"
>
      <!-- Modal Header -->
      <div class="bg-[#9A247B] text-white p-[20px] py-[12px] pr-[10px] flex justify-between items-center rounded-t-[10px]">
        <h3 class="s !text-[14px]">รายชื่อศูนย์พักพิงที่เปิดให้ทำการ</h3>
        <button @click="closeModal" class="text-white hover:text-gray-200 bg-white rounded-full">
          <CloseIcon class="w-6 h-6 text-primary" />
        </button>
      </div>

      <div class="p-[20px] pt-[12px] overflow-auto">
        <SearchBox id="search1" placeholder="ค้นหา ชื่อศูนย์พักพิง" class="h-[42px] mb-[10px]"
          v-model="filter.search" />
          <div class="w-full max-h-[454px] overflow-auto">
        <table  class="min-w-[700px]">
          <!-- Table Header -->
          <thead>
            <tr class="">
              <th
                class="w-[491px] text-left s !text-[14px] px-[8px] py-[16px] bg-primary text-[#FFFFFF] rounded-tl-[6px] border-r-[1px] border-solid border-[#FFFFFF] PC_Body2-R">
                ชื่อศูนย์พักพิง
              </th>
              <th
                class="min-w-[169px] text-left s !text-[14px] px-[8px] py-[16px] bg-primary text-[#FFFFFF] border-r-[1px] border-solid border-[#FFFFFF] PC_Body2-R">
                จำนวนผู้ประสบภัย/ความจุ
              </th>
              <th
                class="w-[200px] text-left s !text-[14px] px-[8px] py-[16px] bg-primary text-[#FFFFFF] border-r-[1px] border-solid border-[#FFFFFF] PC_Body2-R">
                เบอร์สำหรับติดต่อ
              </th>
              <th
                class="w-[100px] text-left s !text-[14px] px-[8px] py-[16px] bg-primary text-[#FFFFFF] rounded-tr-[6px] border-r-[1px] border-solid border-[#FFFFFF] PC_Body2-R">
              </th>
            </tr>
          </thead>

          <!-- Table Content -->
          <tbody v-if="sheltersList.length > 0" class="rounded-[20px]">
            <tr v-for="(data, index) in sheltersList" :key="data.id" class="h-[56px]"
              :class="['!border-none', { 'bg-[#FBEFF8]': (index + 1) % 2 === 0 }]">
              <td class="!border-none p-[10px] text-sm"
                :class="index === sheltersList.length - 1 ? 'rounded-bl-[6px]' : ''">
                {{ data.name }}
              </td>

              <td class="!border-none p-[10px] text-sm">{{ data.current_capacity == null ? '-' : new Intl.NumberFormat('th-TH').format(Number(data.current_capacity)) }} / {{ data.max_capacity == null ? '-' : new Intl.NumberFormat('th-TH').format(Number(data.max_capacity)) }}</td>


              <td class="!border-none p-[10px] text-sm">
                {{ data.phone }}
              </td>

              <td class="!border-none p-[10px] text-sm"
                :class="index === sheltersList.length - 1 ? 'rounded-br-[6px]' : ''">
                <div class="flex justify-center items-center">
                  <button
                    class="flex items-center justify-center rounded-[6px] border border-[#B7B2B5] w-[36px] h-[36px] bg-[#FFF]"
                    @click="showShelter(data.id)">
                    <InfoIcon class="w-[20px] h-[20px] text-primary" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>

          <!-- ✅ ถ้าไม่มีข้อมูล -->
          <tbody v-else>
            <tr>
              <td colspan="4" class="text-center py-6 text-[#888] text-sm">
                ไม่พบข้อมูล
              </td>
            </tr>
          </tbody>
        </table>
        </div>
        <PaginationComponent class="mt-[10px]" :items="items" @selectedPage="handlePage" />
      </div>

      <!-- Pagination -->
    </div>
    <!-- Modals -->
    <ShelterInfoModal v-if="showShelterInfo" :shelter="shelterData" :manage="true" @close="showShelterInfo = false" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onBeforeUnmount, onMounted } from 'vue';
import SearchBox from '@/components/Utilities/SearchBox.vue';
import ShelterInfoModal from '../Modals/ShelterInfoModal.vue';
import { useShelterStore } from "@/pinia/shelter";
import axios from 'axios';

const shelterStore = useShelterStore();

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  shelters: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['close']);

const searchQuery = ref('');
const shelterData = ref({});
const showShelterInfo = ref(false);

// mock data ถ้า props.shelters ไม่มี
const sheltersList = ref([])

const sheltersList2 = ref([
  { name: 'ศูนย์อพยพเมือง 2', current_capacity: 278, max_capacity: 300, phone: '0653456789' },
  { name: 'ศูนย์วัดน้ำป่า', current_capacity: 200, max_capacity: 200, phone: '0850006789' },
  { name: 'ศูนย์อพยพเมือง 1', current_capacity: 290, max_capacity: 300, phone: '0903457842' },
  { name: 'ศูนย์แม่ฟ้าหลวง', current_capacity: 579, max_capacity: 1000, phone: '0912236709' },
]);

const items = ref(null);
const filter = ref({
  page: 1,
  search: ''
});
const currentPage = ref(1)
const perPage = 10

// ✅ Computed
const filteredShelters = computed(() => {
  const query = filter.value.search.toLowerCase().trim();

});

// ✅ Watch
watch(() => props.isOpen, (open) => {

  document.body.style.overflow = open ? 'hidden' : '';


  if (open) {
    filter.value.page = 1;
    getShelterDashboard(1);
  } else {
    // filter.value.search = '';
  }
});

let searchTimeout = null;

watch(
  () => filter.value.search,
  () => {
    clearTimeout(searchTimeout); // เคลียร์ timeout เดิมก่อน
    searchTimeout = setTimeout(async () => {
      filter.value.page = 1;
      await getShelterDashboard();
    }, 1000); // รอ 1000ms (1 วินาที)
  }
);

onBeforeUnmount(() => {
  document.body.style.overflow = '';
});

//onMounted
onMounted(async () => {
  if (props.isOpen) {
    await getShelterDashboard(1);
  }
})

// ✅ Methods
function closeModal() {
  emit('close');
}

async function getShelterDashboard(page = null) {

  const params = {
    status: 1,
    paginate: perPage,
    page: page ?? filter.value.page ?? 1,
    search: filter.value.search || '',
  };

  try {
    const s = await shelterStore.getShelter(params)
    const data = s.data.data.data
    sheltersList.value = data
    items.value = s.data.data
    console.log('GET getShelterDashboard : ', s);

  } catch (error) {
    console.error('GET getShelterDashboard err : ', error);
    throw error
  }
}

function formatThaiDate(dateStr) {
  const [year, month, day] = dateStr.split('-').map(Number);
  const thaiMonths = [
    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
  ];

  return `${day} ${thaiMonths[month - 1]} ${year + 543}`;
}

async function showShelter(id) {
  try {
    // console.log('showShelter : ', id);

    // NOTE: ชื่อมกับ API
    const apiRes = await shelterStore.getShelterById(id);
    const s = apiRes.data;
    console.log('showShelter : ', s.data);






    shelterData.value = {
      image: s.data.image,
      name: s.data.name,
      phone: s.data.phone,
      status: s.data.status = 1 ? 'เปิดใช้งาน' : 'ปิดใช้งาน',
      founded: formatThaiDate(s.data.created_date), //2025-07-22 //'22 กรกฎาคม 2568'
      leader: s.data.leader_name,
      units: s.data.staff_count,
      occupancy: `${s.data.current_capacity} / ${s.data.max_capacity}`,
      gis_map: s.data.gis_map,
      google_maps: s.data.google_maps,
    };

    showShelterInfo.value = true;
  } catch (err) {
    console.error('getShelter failed:', err);
  }
}

async function handlePage(page) {
  // เช่น filter.value.page = page;
  // getData();
  currentPage.value = page;
  filter.value.page = page;
  await getShelterDashboard(page);
}
</script>
